import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {LoanSettlement} from '../model/loan-settlement/LoanSettlement';

@Injectable()
export class LoanSettlementService {
    private httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getByLoanId(loanId: string): Promise<LoanSettlement[]> {
        const url = `${this.configService.getLoanServiceUrl()}/loan-settlements?loanId=${loanId}`;
        return this.httpClient.get<LoanSettlement[]>(url).toPromise();
    }
}
